import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import SelfSignUpContainer from './SelfSignUpContainer';
import { getProductPlanFromSlug } from './productPlan';

type SelfSignUpPlanRouteProps = {
  afsSsupMenuEmbedded: boolean;
  billingJeanSsupSysco?: boolean;
  hasExistingRestaurant: boolean;
  isAuthenticated: boolean;
};

export const SelfSignUpPlanRoute = ({ afsSsupMenuEmbedded, billingJeanSsupSysco, hasExistingRestaurant, isAuthenticated }: SelfSignUpPlanRouteProps) => {
  const { plan } = useParams<{ plan: string }>();

  if (!afsSsupMenuEmbedded) {
    return <Redirect to="/sign-up" />;
  }

  if (isAuthenticated && hasExistingRestaurant) {
    return <Redirect to="/sign-up/existing-account" />;
  }

  const productPlan = getProductPlanFromSlug(plan);

  if (!productPlan || (productPlan === 'sysco_premier' && !billingJeanSsupSysco)) {
    return <Redirect to="/sign-up/starter" />;
  }

  return <SelfSignUpContainer productPlan={productPlan} />;
};
